// QA Industry-specific tag categories and colors
export const TAG_CATEGORIES = {
  // Test Types
  smoke: { color: "#e8f5e8", borderColor: "#4caf50", textColor: "#2e7d32" },
  regression: {
    color: "#fff3e0",
    borderColor: "#ff9800",
    textColor: "#e65100",
  },
  integration: {
    color: "#f3e5f5",
    borderColor: "#9c27b0",
    textColor: "#6a1b9a",
  },
  e2e: { color: "#e0f2f1", borderColor: "#009688", textColor: "#00695c" },
  unit: { color: "#e3f2fd", borderColor: "#2196f3", textColor: "#1565c0" },

  // Functional Areas
  auth: { color: "#fce4ec", borderColor: "#e91e63", textColor: "#ad1457" },
  payment: { color: "#f1f8e9", borderColor: "#8bc34a", textColor: "#558b2f" },
  navigation: {
    color: "#e8eaf6",
    borderColor: "#3f51b5",
    textColor: "#283593",
  },
  form: { color: "#fff9c4", borderColor: "#cddc39", textColor: "#827717" },
  api: { color: "#f3e5f5", borderColor: "#9c27b0", textColor: "#6a1b9a" },
  ui: { color: "#e0f7fa", borderColor: "#00bcd4", textColor: "#00838f" },

  // Non-functional
  performance: {
    color: "#ffecb3",
    borderColor: "#ffc107",
    textColor: "#f57c00",
  },
  security: { color: "#ffcdd2", borderColor: "#f44336", textColor: "#c62828" },
  accessibility: {
    color: "#e1f5fe",
    borderColor: "#03a9f4",
    textColor: "#0277bd",
  },
  usability: { color: "#f9fbe7", borderColor: "#aed581", textColor: "#689f38" },

  // Environment/Browser
  //chrome: { color: "#e8f5e8", borderColor: "#4caf50", textColor: "#2e7d32" },
  //firefox: { color: "#fff3e0", borderColor: "#ff9800", textColor: "#e65100" },
  //safari: { color: "#e3f2fd", borderColor: "#2196f3", textColor: "#1565c0" },
  //edge: { color: "#e0f2f1", borderColor: "#009688", textColor: "#00695c" },
  //mobile: { color: "#fce4ec", borderColor: "#e91e63", textColor: "#ad1457" },
  //desktop: { color: "#e8eaf6", borderColor: "#3f51b5", textColor: "#283593" },

  // Status/State
  flaky: { color: "#fff8e1", borderColor: "#ff9800", textColor: "#ef6c00" },
  stable: { color: "#e8f5e8", borderColor: "#4caf50", textColor: "#2e7d32" },
  new: { color: "#e1f5fe", borderColor: "#03a9f4", textColor: "#0277bd" },
  deprecated: {
    color: "#f5f5f5",
    borderColor: "#9e9e9e",
    textColor: "#616161",
  },
  rejected: { color: "#ffebee", borderColor: "#f44336", textColor: "#c62828" },
  accepted: { color: "#e8f5e9", borderColor: "#4caf50", textColor: "#2e7d32" },
};

export interface TagStyle {
  color: string;
  borderColor: string;
  textColor: string;
}

export const getTagStyle = (tag: string): TagStyle => {
  const normalizedTag = tag.toLowerCase();
  const category = TAG_CATEGORIES[normalizedTag as keyof typeof TAG_CATEGORIES];

  if (category) {
    return category;
  }

  // Default style for unknown tags
  return {
    color: "#e3f2fd",
    borderColor: "#2196f3",
    textColor: "#1565c0",
  };
};
